import React, { useState } from "react";
import { Button, ButtonToolbar, Loader, Container, Modal } from "rsuite";
import "./Singers.css";
import { useTranslation } from "react-i18next";
import Singers from "./Singers";

const SingersModal = ({
  companyId,
  storeId,
  openModal,
  setOpenModal,
  onSelectSinger,
  ...props
}: {
  companyId?: number;
  storeId?: number;
  openModal: boolean;
  setOpenModal: Function;
  onSelectSinger?: Function;
}) => {
  const { t } = useTranslation();

  const [loader, setLoader] = useState(false);

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Modal
        open={openModal}
        backdrop={false}
        onClose={(e: any) => {
          setOpenModal("");
        }}
        size="lg"
        className="entity-picker-modal"
      >
        <Modal.Header>
          <h4 className="text-center entity-picker-title">
            {t("SELECT")} {t("OR")} {t("ADD")} {t("SINGER")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="add-singer entity-picker-body">
            <Singers
              withHeader={false}
              onSelectSinger={onSelectSinger}
              multiSelect={false}
              showCreateForm={false}
            />
            <ButtonToolbar className="btn-center entity-picker-footer">
              <Button
                onClick={(e: any) => setOpenModal("")}
                color="red"
                appearance="primary"
              >
                {t("CLOSE")}
              </Button>
            </ButtonToolbar>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SingersModal;
